<empathy-viewer-card [fullSize]="true" [noTitle]="true">
  <div slot="content">
    <div #carouselSwipeContainer class="carousel-view__container" [class.is-phone]="isPhone$()">
      <div class="carousel-view__container__actions">
        <button [title]="'system.carousel.moveToPreviousCard' | translate" class="prev-btn" [disabled]="activeCard$() === 0" (click)="onPrev()">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </button>

        <empathy-viewer-progress-bar [color]="'primary'" [progress]="activeCard$() | progress: visibleCards$().length"></empathy-viewer-progress-bar>

        @if (activeCard$() < visibleCards$().length - 1) {
          <button [title]="'system.carousel.moveToNextCard' | translate" class="next-btn" [disabled]="!canGoNext$()" (click)="onNext()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        }
      </div>

      <div class="carousel-view__container__question" scrollToTop [trigger]="!questionsGrp().get(visibleCards$()[activeCard$()].id)?.value">
        <div [id]="visibleCards$()[activeCard$()].id" class="carousel-view__container__question__title fs__xxxl fw__500">
          @if (!!visibleCards$()[activeCard$()].stimulus?.mediaId) {
            <empathy-option-media
              [media]="visibleCards$()[activeCard$()].stimulus"
              [altText]="visibleCards$()[activeCard$()].text"
              [align]="'center'"
              [noBorder]="true"
            >
              <span class="fs__xxxl fw__500" [innerHTML]="visibleCards$()[activeCard$()].text"></span>
            </empathy-option-media>
          } @else {
            <span class="fs__xxxl fw__500" [innerHTML]="visibleCards$()[activeCard$()].text"></span>
          }
        </div>

        @if (activeCard$() < visibleCards$().length - 1) {
          @for (cardQuestion of questionsGrp().value | keyvalue; track cardQuestion.key) {
            @if (cardQuestion.key === visibleCards$()[activeCard$()].id) {
              <div [@stagger]="visibleCards$()[activeCard$()].id" class="carousel-view__container__question__choices">
                @for (option of visibleOptions$(); track option.id) {
                  @if (question().useOtherInd && question().useOtherPosition === $index) {
                    <ng-container *ngTemplateOutlet="other"></ng-container>
                    <ng-container *ngTemplateOutlet="otherText"></ng-container>
                  }

                  @if (!!option.stimulus?.mediaId) {
                    <empathy-option-media [media]="option.stimulus" [altText]="option.text" (clicked)="onMediaChecked(option)">
                      <ng-container [ngTemplateOutlet]="carouselCheckbox"></ng-container>
                    </empathy-option-media>
                  } @else {
                    <div class="carousel-view__container__question__choices__checkbox" [class.use-media]="useMedia$()" (click)="onMediaChecked(option)">
                      <ng-container [ngTemplateOutlet]="carouselCheckbox"></ng-container>
                    </div>
                  }

                  <ng-template #carouselCheckbox>
                    <mat-checkbox
                      color="accent"
                      [checked]="questionsGrp().get(visibleCards$()[activeCard$()].id).get('value').value | checked: option.value"
                      [disabled]="
                        !(questionsGrp().get(visibleCards$()[activeCard$()].id).get('value').value | checked: option.value) &&
                        question().maxLength > 0 &&
                        questionsGrp().get(visibleCards$()[activeCard$()].id).get('value').value?.length === question().maxLength
                      "
                      surveyAutoFocus
                      [animationDelay]="300"
                      [condition]="
                        (questionsGrp().get(visibleCards$()[activeCard$()].id).get('value').value | checked: option.value) &&
                        cardQuestion.key === visibleCards$()[activeCard$()].id
                      "
                      (click)="$event.stopPropagation()"
                      (change)="onChecked($event, option)"
                    >
                      <div class="survey-viewer__html-content fs__md" [innerHTML]="option.text"></div>
                    </mat-checkbox>
                  </ng-template>

                  @if (question().useOtherInd && question().useOtherPosition >= visibleOptions$().length && $last) {
                    <ng-container *ngTemplateOutlet="other"></ng-container>
                    <ng-container *ngTemplateOutlet="otherText"></ng-container>
                  }
                }

                <ng-template #other>
                  <div
                    class="carousel-view__container__question__choices__checkbox"
                    [class.use-media]="useMedia$()"
                    (click)="onMediaChecked({ value: otherOption.value })"
                  >
                    <mat-checkbox
                      color="accent"
                      [checked]="questionsGrp().get(visibleCards$()[activeCard$()].id).get('value').value | checked: otherOption.value"
                      [disabled]="
                        question().maxLength > 0 && questionsGrp().get(visibleCards$()[activeCard$()].id).get('value').value?.length === question().maxLength
                      "
                      (click)="$event.stopPropagation()"
                      (change)="onChecked($event, otherOption)"
                    >
                      <span class="survey-viewer__html-content fs__md">{{ otherOption.text | translate }}</span>
                    </mat-checkbox>
                  </div>
                </ng-template>

                <ng-template #otherText>
                  @if (questionsGrp().get(visibleCards$()[activeCard$()].id).get('value').value | checked: otherOption.value) {
                    <div class="question-form__input">
                      <span class="label survey-viewer__html-content fs__md fw__400" [innerHTML]="question().otherLabel"></span>
                      <mat-form-field appearance="outline" class="eiq-survey-textarea">
                        <textarea
                          matInput
                          surveyAutoFocus
                          [formControl]="questionsGrp().get(visibleCards$()[activeCard$()].id).get('otherText') | toFormControl"
                          [required]="questionsGrp().get(visibleCards$()[activeCard$()].id).get('value').value.includes('OTHER')"
                          autocomplete="off"
                        ></textarea>
                      </mat-form-field>
                    </div>
                  }
                </ng-template>
              </div>
            }
          }
        }
      </div>
    </div>
  </div>
</empathy-viewer-card>
